import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=58082ef7&scoped=true"
import script from "./Robot.vue?vue&type=script&lang=ts"
export * from "./Robot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58082ef7",
  null
  
)

export default component.exports